import {Component, Input, OnInit} from '@angular/core';
import {SignInForm} from '@shared/sign-in/@form/sign-in-form';

@Component({
  selector: 'app-password-input[signInForm][showInvalidFeedback]',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss']
})
export class PasswordInputComponent implements OnInit {
  @Input() signInForm!: SignInForm;
  @Input() showInvalidFeedback!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
